import { ErrorBoundary } from '@backstage/core-components';
import { EventList } from './EventList/EventList.tsx';

export const CalendarEventsWidget = () => {
  return (
    <ErrorBoundary>
      <EventList rowLimit={5} widgetMode />
    </ErrorBoundary>
  );
};
